import React, { useReducer } from 'react';
import { AuthConsumer } from '../lib/contexts/AuthContext';
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { Form, Row, Col, Container, FormGroup, FormControl } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import spinner from '../static/images/spinner.gif';
import { XCircleFill } from 'react-bootstrap-icons';

const ForgotPassword = () => {

    const initialState = {
        error: '',
        passwordResetSent: false,
        username: { value: '', required: true, touched: false, invalid: true, message: ''},
        isLoading: false
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'idBlurred':
                return {
                    ...state,
                    [action.payload]: {
                        ...state[action.payload],
                        touched: true
                    }
                }
            case 'idChanged':
                return {
                    ...state,
                    [action.payload.id]: {
                        ...state[action.payload],
                        value: action.payload.value,
                    }
                }
            case 'error':
                return {
                    ...state,
                    error: action.payload
                }
            case 'passwordResetSent':
                return {
                    ...state,
                    passwordResetSent: action.payload,
                    isLoading: false
                }
            case 'username':
                return {
                    ...state,
                   username: action.payload
                }
            case 'isLoading':
                return {
                    ...state,
                    isLoading: true
                }
            default:
                throw new Error();
        }
    }

    const [forgotPasswordState, dispatch] = useReducer(reducer, initialState);

    const handleBlur = (event) => 
    {
        const { id } = event.target;
        dispatch({ type: 'idBlurred', payload: id})
    }

    const handleChange = (event) =>
    {
        const { id, value }  = event.target;
        dispatch({ type: 'idChanged', payload: {id, value} });
    }  
    
    const shouldMarkError = (id) => {
        const field = forgotPasswordState[id];
        const result = field.value === '' && field.touched;
        return result;
    };
 
    const formIsValid = () =>
    {
        var invalidFields = Object.keys(forgotPasswordState).filter(field=>forgotPasswordState[field].hasOwnProperty('invalid') 
            && forgotPasswordState[field].value === '');
        return invalidFields.length === 0;
    };

    const submit = (authContext) => (event) =>
    {
        event.preventDefault();
        const { username } = forgotPasswordState;

        if (formIsValid()) {
            dispatch({ type: 'isLoading', payload: true })
            let forgotPassword = { username: username.value };
            fetch('api/auth/forgot-password', {
                method: "POST",
                headers: {  
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': 'Bearer ' + localStorage.accessToken
                },
                body: JSON.stringify({...forgotPassword})
            })
            .then(response => {
                if (response.status === 200) { 
                    dispatch({ type: 'passwordResetSent', payload: true });
                }
                throw new Error('There was a problem resetting your password. Please try again.');
            })
            .catch(error=>{
                dispatch({ type: 'isLoading', payload: false });
                dispatch({ type: 'error', payload: error.message });
            });
        }
    }

    const { error, passwordResetSent, username, isLoading } = forgotPasswordState;

    return (
        <Container className="panel-body panel-default sm-panel">
            {passwordResetSent &&
                <>
                    <h3 className="section mt-0">Password Reset Request Received</h3>
                    <Row className="border-between">
                        <Col sm={12} className="pr-50">
                            <p>We have received your request to reset your password. You should receive an email with a link and instructions for completing your Password Reset request.</p>
                            <p>If you have any questions, please contact our Customer Service Team at (800) 763-0234</p>
                            <br/>
                            <div className="form-group text-left">
                                <Link to="/" className="btn btn-primary">Return Home</Link>
                            </div>
                        </Col>
                    </Row>
                </>
            }

            {!passwordResetSent &&
                <AuthConsumer>
                    {context=>(
                        <Form onSubmit={submit(context)} >
                            <div className="header section">RESET YOUR PASSWORD</div>
                            <Row className="section">
                                <Col sm={12} className="pr-50">
                                    <div className="section muted-bold h40">
                                        Please enter your username. We will send you an email to reset your password.
                                    </div>
                                    {error !== '' &&
                                        <div className="alert alert-danger section" role="alert">
                                            <span aria-hidden="true" className='me-1'>{<XCircleFill />}</span> 
                                            <span className="sr-only">Error:</span>
                                            {" " + error}
                                        </div>
                                    }
                                    <FormGroup>
                                        <FormControl
                                            type="text" 
                                            id="username" 
                                            name="username"
                                            placeholder="username"
                                            value={username.value}
                                            isInvalid={shouldMarkError("username") ? " error" : null}
                                            onBlur={handleBlur}
                                            onChange={handleChange} />
                                        <FormControl.Feedback />
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        {!isLoading &&
                                            <button 
                                                type="submit" 
                                                className="btn btn-primary"
                                                disabled={!formIsValid()}
                                            >
                                                Send Email
                                            </button>
                                        }
                                        {isLoading &&
                                            <span>Loading...<img src={spinner} alt="Loading ..." /></span>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </AuthConsumer>
            }
        </Container>
    );

}

export default WithApiAccess(ForgotPassword);